import { useState, useCallback, useLayoutEffect } from "react";

export const COUNTABLE_PARAM_NAME = "data-quote-group-element";

const DUMMY_LINE_NO = "0";

export function makeCountableParam(lineNo?: string) {
  return {
    [COUNTABLE_PARAM_NAME]: lineNo ?? DUMMY_LINE_NO,
  };
}

export const useLineNoOffset = () => {
  const [ref, setRef] = useState<HTMLElement | null>(null);

  const [allElements, setAllElements] = useState<HTMLElement[]>([]);

  useLayoutEffect(() => {
    if (!ref) {
      return;
    }
    const newAllElements = Array.from(ref.querySelectorAll(`[${COUNTABLE_PARAM_NAME}]`)) as HTMLElement[];
    if (!arraysAreEqual(newAllElements, allElements)) {
      setAllElements(newAllElements);
    }
  });

  const makeOffsetStyle = useCallback(
    (lineNo: string) => {
      if (!ref) {
        return undefined;
      }
      const lineNoToIndex = {} as Record<string, number>;
      allElements.forEach((el, index) => {
        const lineNo = el.getAttribute(COUNTABLE_PARAM_NAME);
        if (lineNo) {
          lineNoToIndex[lineNo] = index + 1;
        }
      });
      return {
        style: { gridRow: lineNoToIndex[lineNo] },
      };
    },
    [allElements, ref]
  );

  return {
    makeOffsetStyle,
    setRef,
  };
};

export const useSectionSpan = () => {
  const [ref, setRef] = useState<HTMLElement | null>(null);

  const [allElements, setAllElements] = useState<HTMLElement[]>([]);

  useLayoutEffect(() => {
    if (!ref) {
      return;
    }
    const newAllElements = Array.from(ref.querySelectorAll(`[${COUNTABLE_PARAM_NAME}]`)) as HTMLElement[];
    if (!arraysAreEqual(newAllElements, allElements)) {
      setAllElements(newAllElements);
    }
  });

  const span = allElements.length;

  return {
    span,
    sectionProps: {
      ref: setRef,
      style: { gridRowEnd: `span ${span}` },
    },
  } as {
    span: number;
    sectionProps: React.HTMLAttributes<HTMLElement>;
  };
};

function arraysAreEqual(arr1: unknown[], arr2: unknown[]) {
  return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
}
